module.exports = __webpack_public_path__ + "img/health_resources_mask.7d5abbf8.jpeg";